import { observer } from "mobx-react-lite";
import React from "react";
import { withFormWrapper } from "../withFormWrapper";
import { RadioButtons } from "../RadioButtons";
var warned = false;
var RawButtonRadio = observer(function (_a) {
    var name = _a.name, onChange = _a.onChange, options = _a.options;
    if (!warned) {
        warned = true;
        console.warn("[piston-ux] ButtonRadio has been deprecated. Use <RadioButtons />.");
    }
    return React.createElement(RadioButtons, { name: name, onChange: onChange, options: options });
});
export var ButtonRadio = withFormWrapper({
    WrappedComponent: RawButtonRadio,
});
